import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ENVIRONMENT, Environment } from '@environment';
import { NotificationService } from '@noovle/ui-libraries';
import { Observable } from 'rxjs';

@Injectable()
export class UserInactivityInterceptor implements HttpInterceptor {
  counter = 0;

  constructor(
    private afAuth: AngularFireAuth,
    private notificationService: NotificationService,
    @Inject(ENVIRONMENT) private env: Environment
  ) {
    this.afAuth.user.subscribe((user) => {
      if (user) {
        setInterval(() => {
          this.counter += 1;
          this.checkCounter();
        }, 1000);
      }
    });
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    this.counter = 0;
    return next.handle(request);
  }

  private checkCounter() {
    switch (this.counter) {
      case this.env.logoutTimeout:
        this.logoutAndReset();
        break;
      case this.env.warningTimeout: {
        const inputs = {
          message: `La sessione risulta inattiva, tra 5 min verrai automaticamente disconnesso, clicca su Prosegui per rimanere loggato`,
          nextBtn: 'Prosegui',
          cancelBtn: '',
          classConfirmBtn: 'btn-primary',
          classCancelBtn: 'd-none',
        };
        this.notificationService
          .openWarningUser(inputs)
          .then(() => (this.counter = 0))
          .catch(() => (this.counter = 0));
      }
    }
  }

  private logoutAndReset() {
    this.counter = 0;
    this.afAuth.signOut();
    location.reload();
  }
}
